import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetMarkersFromSequenceQueryVariables = Types.Exact<{
  sequenceId: Types.Scalars['ID']['input'];
}>;


export type GetMarkersFromSequenceQuery = { __typename?: 'Query', getMarkersFromSequence: Array<{ __typename?: 'Marker', id?: string | null, name: string, comments: string, start: number, duration?: number | null, deleted: boolean, frameCommentId: string } | null> };


export const GetMarkersFromSequence = /*#__PURE__*/ gql`
    query GetMarkersFromSequence($sequenceId: ID!) {
  getMarkersFromSequence(sequenceId: $sequenceId) {
    id
    name
    comments
    start
    duration
    deleted
    frameCommentId
  }
}
    ` as unknown as DocumentNode<GetMarkersFromSequenceQuery, GetMarkersFromSequenceQueryVariables>;

          

          export const useGetMarkersFromSequenceQuery = (options?:QueryHookOptions<GetMarkersFromSequenceQuery, GetMarkersFromSequenceQueryVariables>) => useQuery(GetMarkersFromSequence, options);

          

          export type GetMarkersFromSequenceQueryOptions = QueryHookOptions<GetMarkersFromSequenceQuery, GetMarkersFromSequenceQueryVariables>;

          

          export const useGetMarkersFromSequenceLazyQuery = (options?:LazyQueryHookOptions<GetMarkersFromSequenceQuery, GetMarkersFromSequenceQueryVariables>) => useLazyQuery(GetMarkersFromSequence, options);

          

          export type GetMarkersFromSequenceQueryResult = ReturnType<typeof useGetMarkersFromSequenceQuery>;

          
